<template>
    <!-- Single root so class bindings (e.g. drawer open state) fall through from the parent. On desktop this is a
         static left sidebar; on mobile it is an off-canvas drawer toggled by the header's burger button. -->
    <nav class="app-nav">
        <div class="app-nav-head">
            <span class="app-nav-brand">{{ clientName }}</span>
            <button class="app-nav-close" type="button" :aria-label="$t('back')" @click="$emit('navigate')">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>
        <button v-for="item in items" :key="item.name" type="button"
                class="app-nav-item" :class="{ active: isActive(item) }" @click="go(item)">
            <i :class="item.icon"></i>
            <span>{{ $t(item.label) }}</span>
        </button>
    </nav>
</template>

<script>
export default {
    name: 'AppNav',
    emits: ['navigate'],
    data() {
        return {
            items: [
                { name: 'home', label: 'home', icon: 'fa-solid fa-house' },
                { name: 'calendar', label: 'availableSessions', icon: 'fa-solid fa-calendar-days' },
                { name: 'my-sessions', label: 'mySessions', icon: 'fa-solid fa-calendar-check' },
                { name: 'profile', label: 'profile', icon: 'fa-solid fa-user' }
            ]
        };
    },
    computed: {
        clientName() {
            const client = this.$store.getters.selectedClient;
            if (!client) return '';
            return client.sport_center_name || client.name;
        }
    },
    methods: {
        isActive(item) {
            return this.$route.name === item.name;
        },
        go(item) {
            if (this.$route.name !== item.name) this.$router.push({ name: item.name });
            this.$emit('navigate');
        }
    }
};
</script>
